import React from 'react';
import { Spinner } from 'react-bootstrap';

const LoadingSpinner = () => {
  return <Spinner animation='border' />;
};

export default LoadingSpinner;
